import { render, staticRenderFns } from "./DiagnosticModal.vue?vue&type=template&id=2f9db435"
import script from "./DiagnosticModal.vue?vue&type=script&lang=js"
export * from "./DiagnosticModal.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticModal.vue?vue&type=style&index=0&id=2f9db435&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports